import { jwtDecode } from 'jwt-decode';

export const handleKeycloakEvent = (event, error, keycloak, setUserSession) => {
  const token = keycloak.token;
  if (!token) {
    console.error('No token found');
    return;
  }

  const decoded = jwtDecode(token);
  const roles = decoded?.resource_access?.smartshield?.roles?.[0];

  console.log(decoded);
  const fullname = decoded.name;
  const email = decoded.email;
  const fetchData = (fakeDataUrl) => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      try {
        fetch(fakeDataUrl, {
          headers: { Authorization: `Bearer ${keycloak.token}` },
        })
          .then((res) => res.json())
          .then((data) => {
            // Handle fetched data
            console.log('Fetched data:', data);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      } catch (error) {
        console.error('Error calling fetch:', error);
      }
    }
  };
  if (event === 'onAuthSuccess') {
    fetchData(window.REACT_APP_API_PURE + 'user/logged');
    setUserSession(keycloak.token, keycloak.refreshToken, email, roles, fullname);
    if (!roles || roles === 'undefined') {
      sessionStorage.clear();
      sessionStorage.setItem('token', 'gada');
      sessionStorage.setItem('role', 'norole');
    }
  } else if (event === 'onAuthError') {
    console.error('Authentication error', error);
  }
};
